import { createTheme } from '../utils/create-theme';
export var BLAZE_THEME = createTheme('blaze', {
  activeMode: 'light',
  light: {
    color: {
      lineMid: '#00000022',
      appChrome: '#F5F5F5',
      primary: '#FF5307',
      primaryDarker: '#DA5225',
      primaryLight: '#FFCBB5',
      primaryLighter: '#F05A29',
      primaryBright: '#FA4F0B',
      primaryVeryLight: '#FEF0EC',
      link: '#FF5307',
      linkHover: '#000000',
      navigationActive: '#FF5307',
      accentLight: '#FFCBB5',
      accentDark: '#DA5225'
    }
  },
  dark: {
    color: {
      link: '#7DB248',
      linkHover: '#7DB248'
    }
  }
});
export default BLAZE_THEME;